export default function createDoughnutChartOptions(unit) {
  return {
    animation: false,
    legend: { display: false },
    cutoutPercentage: 65,
    plugins: {
      labels: [
        {
          render: args => {
            return args.index < 10 && args.percentage > 4
              ? `${args.label} ${args.percentage}%`
              : "";
          },
          fontColor: args => {
            return args.backgroundColor;
          },
          fontSize: 12,
          fontStyle: "bold",
          position: "outside",
          outsidePadding: 65,
          textMargin: 4
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: (tooltipItems, data) => {
          return `${data.labels[tooltipItems.index]}: ${
            data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
          } ${unit}`;
        }
      }
    }
  };
}
